import { FaDiscord } from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri"
import SocialButton from "./SocialButton";

export default function Socials() {
    const iconColour = "#26bbff";
    const iconSize = "100%";

    return (
        <div className="flex items-center gap-4">    
            <SocialButton 
                socialURL={"https://twitter.com/_astral_labs"} 
                socialIcon={<RiTwitterXLine color={iconColour} size={iconSize} />} 
            />
            <SocialButton 
                socialURL={"https://discord.gg/EXDay6NQbH"} 
                socialIcon={<FaDiscord color={iconColour} size={iconSize} />} 
            />
        </div>
    )
}